<template>
  <div class="page-component">
    <el-dialog
      title="添加测试用例"
      :visible.sync="testCaseVisible"
      width="800px"
      :before-close="handleClose"
      destroy-on-close
      modal-append-to-body
      lock-scroll
      custom-class="case-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <div class="dialog-box">
          <div class="dialog-title">添加测试用例</div>
          <div class="dialog-content">（注意：文本框内换行默认添加"\n"）</div>
        </div>
      </div>
      <el-form :model="caseForm" :rules="caseRules" ref="caseForm">
        <el-form-item label="输入：" prop="type">
          <el-radio-group v-model="caseForm.type">
            <el-radio :label="1">单变量</el-radio>
            <el-radio v-if="!caseType" :label="2">多变量</el-radio>
            <el-button
              v-show="caseForm.type == 2"
              @click="handleAddCase"
              size="mini"
              >添加</el-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="inputContent"
          class="mb-12"
          v-if="caseForm.type == 1"
        >
          <el-input
            size="small"
            type="textarea"
            class="mt-12 inputClass"
            placeholder="请输入变量值"
            v-model="caseForm.inputContent"
          ></el-input>
          <div class="code-box" v-if="caseType">
            <OnlineCodeOutput
              class="code-content"
              :language.sync="getLanguage"
              :inputCode.sync="program.inputCode"
              :key.sync="program.name"
              :env="env"
              :isVertical="true"
              title="测试代码"
              :showDownload="false"
              :showOutInput="true"
              :answer.sync="program.outputCode"
            />
            <el-button
              type="success"
              class="code-button"
              size="small"
              @click="runCode"
              :loading="btnLoading"
              >运行</el-button
            >
          </div>
        </el-form-item>
        <el-form-item prop="inputList" class="mb-12" v-else>
          <div
            class="case-item mt-12"
            v-for="(item, index) in caseForm.inputList"
            :key="index"
          >
            <el-input
              size="small"
              type="textarea"
              placeholder="请输入变量名"
              class="w-135"
              v-model="item.key"
            ></el-input>
            <el-input
              size="small"
              type="textarea"
              placeholder="请输入变量值"
              class="w-300 ml-12"
              v-model="item.value"
            ></el-input>
            <i
              class="ml-12 el-icon-remove-outline delete-icon"
              v-if="index > 1"
              @click="handleDelete(index)"
              >删除</i
            >
          </div>
        </el-form-item>
        <el-form-item label="输出：" prop="output">
          <el-input
            v-if="!caseType"
            size="small"
            type="textarea"
            placeholder="输出值"
            v-model="caseForm.output"
          ></el-input>
          <div class="table-content" v-if="caseType">
            <div v-if="wrongData" class="table-wrong">
              {{ wrongData }}
            </div>
            <table border="1" v-else>
              <thead>
                <tr>
                  <th
                    class="table-head"
                    v-for="(item, index) in columnName"
                    :key="index"
                  >
                    {{ item }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(outItem, outIndex) in caseForm.outputTarget"
                  :key="outIndex"
                >
                  <td class="table-td" v-for="name in columnName" :key="name">
                    {{ outItem[name] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-checkbox
          style="float: left; font-weight: 400"
          v-model="caseForm.display"
          >在答题页面展示（用户可见）</el-checkbox
        >
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OnlineCodeOutput from "@/components/OnlineCodeOutput.vue";
import codeService from "@/global/service/code";
const env = process.env.NODE_ENV == "development" ? "vip" : "prod";

import common from "./common";
export default {
  mixins: [common],
  props: {
    testCaseVisible: {
      default: false,
      type: Boolean
    },
    caseItem: {
      type: Object
    },
    currentLanguage: {
      type: Object
    },
    caseList: {
      type: Array
    }
  },
  data() {
    return {
      caseForm: {
        type: 1, // 类型；1 单变量；2 多变量
        inputContent: null,
        inputList: [
          { key: null, value: null },
          { key: null, value: null }
        ],
        output: null,
        display: true,
        outputTarget: null
      },
      caseRules: {
        type: [
          {
            required: true,
            message: "请输入变量值",
            trigger: ["blur"]
          }
        ],
        inputContent: [
          {
            validator: this.validateInput,
            message: "请输入变量值",
            trigger: ["blur"]
          }
        ],
        inputList: [
          {
            validator: this.validateInput,
            trigger: ["blur"]
          }
        ]
        // output: [
        //   {
        //     required: true,
        //     message: "请输入输出值",
        //     trigger: ["blur"]
        //   }
        // ]
      },
      caseType: null,
      program: {
        name: this.currentLanguage.name,
        inputCode: "",
        outputCode: ""
      },
      env,
      columnName: [],
      outputList: [],
      language_t: ["Oracle", "Mysql 8"],
      btnLoading: false,
      wrongData: ""
    };
  },
  components: {
    OnlineCodeOutput
  },
  watch: {
    caseItem: {
      handler(val) {
        if (val) {
          if (this.caseType) {
            this.columnName = Object.keys(this.caseItem.outputTarget[0]);
          }
          this.caseForm = {
            type: val.type,
            inputContent: val.type == 2 ? null : val.input,
            inputList:
              val.type == 2
                ? val.input
                : [
                    { key: null, value: null },
                    { key: null, value: null }
                  ],
            output: val.output,
            display: val.display,
            outputTarget: val.outputTarget
          };
          if (val.id) {
            this.caseForm.id = val.id;
          }
        }
      },
      deep: true
    },
    currentLanguage() {
      this.caseType = this.language_t.includes(this.currentLanguage.name);
    }
  },
  created() {
    this.caseType = this.language_t.includes(this.currentLanguage.name);
  },
  methods: {
    runCode() {
      if (!this.caseForm.inputContent) {
        this.$message.error("请输入变量值");
        return;
      }
      if (!this.program.inputCode) {
        this.$message.error("请输入测试代码");
        return;
      }
      this.btnLoading = true;
      const params = {
        language: this.getLanguage,
        cases: [{ input: this.caseForm.inputContent }],
        code: window.btoa(encodeURIComponent(this.program.inputCode)),
        variableType: "SINGLE"
      };
      codeService
        .questionCase(params)
        .then(res => {
          if (res.msg) {
            this.wrongData = res.msg;
            return;
          }
          this.wrongData = "";
          this.columnName = Object.keys(res.data[0]);
          this.caseForm.output = res.data;
          this.caseForm.outputTarget = res.data;
          // const columnLength = res.data.rows[0].length - 1;
          // var item = {};
          // const outputList = [];
          // res.data.rows.forEach(row => {
          //   row.forEach((data, index) => {
          //     res.data.metaData.forEach((meta, mIndex) => {
          //       if (index == mIndex) {
          //         item[meta.name] = data;
          //       }
          //     });
          //     if (index == columnLength) {
          //       outputList.push(item);
          //       item = {};
          //     }
          //   });
          // });
          // this.caseForm.output = res.data;
          // this.caseForm.outputTarget = outputList;
          // this.columnName = Object.keys(outputList[0]);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    validateInput(rule, value, callback) {
      if (this.caseForm.type == 2) {
        let key = value.every(item => item.key);
        let val = value.every(item => item.value);
        if (key && val) {
          callback();
        } else {
          callback(new Error(`请输入${key ? "变量值" : "变量名"}`));
        }
      } else {
        if (value) {
          callback();
        } else {
          callback(new Error("请输入变量值"));
        }
      }
    },
    handleSubmit() {
      const { type } = this.caseForm;
      // let output = this.caseType
      //   ? this.caseForm.output.map(item => {
      //       return { ...item };
      //     })
      //   : this.caseForm.output
      //   ? this.caseForm.output
      //   : "";
      const params = {
        type,
        output: this.caseForm.output,
        input:
          this.caseForm.type == 1
            ? this.caseForm.inputContent
            : this.caseForm.inputList,
        id: this.caseForm.id,
        display: this.caseForm.display,
        outputTarget: this.caseForm.outputTarget,
        columnName: this.columnName
      };
      this.$refs.caseForm.validate(valid => {
        if (valid) {
          let keyArr = this.caseForm.inputList?.map(item => item.key);
          if (this.caseForm.type == 2 && this.checkForDuplicates(keyArr)) {
            this.$message.error("输入的变量名重复！");
            return;
          }
          const isRepeat =
            this.caseList &&
            this.caseList?.find(data => {
              return (
                data.type == params.type &&
                JSON.stringify(data.input) == JSON.stringify(params.input) &&
                JSON.stringify(data.output) == JSON.stringify(params.output)
              );
            });

          if (isRepeat) {
            if (!this.caseItem) {
              this.$message.error("请勿提交重复的测试用例");
            } else {
              this.$emit("addCase", params);
              this.handleClose();
              this.columnName = [];
              this.program.inputCode = "";
            }
          } else {
            this.$emit("addCase", params);
            this.handleClose();
            this.columnName = [];
            this.program.inputCode = "";
          }
        }
      });
    },
    checkForDuplicates(array) {
      return new Set(array).size !== array.length;
    },
    handleClose() {
      this.$emit("update:testCaseVisible", false);
      this.caseForm = {
        type: 1,
        inputContent: null,
        inputList: [
          { key: null, value: null },
          { key: null, value: null }
        ],
        output: null,
        display: true
      };
      this.$emit("update:caseItem", null);
    },
    handleAddCase() {
      this.caseForm.inputList.push({ key: null, value: null });
    },
    handleDelete(index) {
      this.caseForm.inputList;
      this.caseForm.inputList.splice(index, 1);
    }
  }
};
</script>

<style lang="less" scoped>
.table-wrong {
  max-height: 100px;
  color: #f56c6c;
}
.dialog-box {
  display: flex;
  align-items: center;
  .dialog-title {
    font-size: 20px;
    font-weight: bolder;
  }
  .dialog-content {
    font-size: 12px;
    color: rgb(179, 179, 179);
    margin-left: 10px;
  }
}
.table-content {
  overflow-y: auto;
  padding: 4px;
  .table-head {
    padding: 0 4px;
    text-align: center;
    font-weight: 500;
  }
  .table-td {
    padding: 2px 4px;
    text-align: center;
  }
}

table,
td {
  border: 1px solid #000000;
  border-collapse: collapse;
}
.case-item {
  display: flex;
  align-items: center;
  // .val-item {
  // flex: 1;
  // }
  .delete-icon {
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
  }
}

.code-box {
  margin: 10px 0;
  height: 200px;
  position: relative;
  /deep/.run-button {
    display: none !important;
  }
  .code-button {
    position: absolute;
    top: 7%;
    right: 2%;
    background: rgb(15, 199, 0);
    border-color: rgb(15, 199, 0);
  }
}
.inputClass {
  /deep/.el-textarea__inner {
    min-height: 60px !important;
  }
}
</style>
